/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';

const LawMenu = () => {
  const { juridico } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  return (
    <div className="card sticky-top text-center">
      <div className="card-header">
        Você está lendo: <br />
        {juridico?.leis[0]?.numero === 'Constituição'
          ? 'Constituiçao Federal'
          : `${juridico?.leis[0]?.tipo} nº ${juridico?.leis[0]?.numero}`}
      </div>
      <ul id="link-fixo" className="list-group list-group-flush">
        <li className="list-group-item">
          <a href="/legislacao">Legislações</a>
        </li>
        <li className="list-group-item">
          <a href="/juridico/view/tipos/2"> Dicas Legais </a>
        </li>
        <li className="list-group-item">
          <a href="/juridico/view/tipos/1"> Jurisprudências </a>
        </li>
        <li className="list-group-item">
          <a href="/juridico/view/tipos/3"> Súmulas </a>
        </li>
        <li className="list-group-item">
          <a href="#"> Voltar ao Topo </a>
        </li>
      </ul>
    </div>
  );
};
export default LawMenu;
